import React from 'react';
import VendorCard from './VendorCard';

function VendorList(props) {
   const { vendors, pagination, onPageChange, openEditVendor, openDeleteVendor } = props;

   if (!vendors.length) {
      return (
         <div className="vendors__empty-state">
            <div className="vendors__empty-icon">
               <i className="fa fa-building-o"></i>
            </div>
            <div className="vendors__empty-text">No vendors found</div>
            <div className="vendors__empty-subtext">Try adjusting your search or filter criteria</div>
         </div>
      );
   }

   const { page, pageSize, total } = pagination;
   const totalPages = Math.ceil(total / pageSize);

   function goToPage(newPage) {
      if (newPage < 1 || newPage > totalPages) return;
      onPageChange(newPage);
   }

   function getVisiblePages(page, totalPages, delta = 2) {
      const pages = [];

      const start = Math.max(1, page - delta);
      const end = Math.min(totalPages, page + delta);

      if (start > 1) {
         pages.push(1);
         if (start > 2) pages.push('...');
      }

      for (let i = start; i <= end; i++) {
         pages.push(i);
      }

      if (end < totalPages) {
         if (end < totalPages - 1) pages.push('...');
         pages.push(totalPages);
      }

      return pages;
   }

   function getCompactPages(page, totalPages) {
      const pages = [];

      if (totalPages <= 1) return [1];

      pages.push(1);

      if (page > 3) {
         pages.push('...');
      }

      const middlePages = [page - 1, page, page + 1].filter((p) => p > 1 && p < totalPages);

      pages.push(...middlePages);

      if (page < totalPages - 2) {
         pages.push('...');
      }

      pages.push(totalPages);

      return [...new Set(pages)];
   }

   //    const visiblePages = getVisiblePages(page, totalPages);

   const visiblePages = getCompactPages(page, totalPages);

   return (
      <div>
         <div className="vendors__card-list">
            {vendors.map(function (vendor) {
               return (
                  <VendorCard key={vendor.id} vendor={vendor} onEdit={openEditVendor} onDelete={openDeleteVendor} />
               );
            })}
         </div>

         <div
            className="pagination-wrapper"
            id="pagination-wrapper"
            style={{
               background: 'rgb(255, 255, 255)',
               borderRadius: '8px',
               boxShadow: 'rgba(0, 0, 0, 0.08) 0px 1px 3px',
               display: 'flex',
            }}
         >
            <div className="pagination-info" id="pagination-info">
               Showing {(page - 1) * pageSize + 1}–{Math.min(page * pageSize, total)} of {total} vendors
            </div>
            <nav>
               <ul className="pagination mb-0">
                  <li className={`vendors__page-item ${page === 1 ? 'disabled' : ''}`}>
                     <a className="vendors__page-link" onClick={() => goToPage(page - 1)}>
                        «
                     </a>
                  </li>

                  {visiblePages.map((p) => {
                     if (p !== '...') {
                        return (
                           <li key={p} className={`vendors__page-item ${p === page ? 'active' : ''}`}>
                              <a className="vendors__page-link" onClick={() => goToPage(p)}>
                                 {p}
                              </a>
                           </li>
                        );
                     }
                  })}

                  <li className={`vendors__page-item ${page === totalPages ? 'disabled' : ''}`}>
                     <a className="vendors__page-link" onClick={() => goToPage(page + 1)}>
                        »
                     </a>
                  </li>
               </ul>
            </nav>
         </div>
      </div>
   );
}

export default VendorList;
